/**
 * 微信环境检测工具
 * 用于检测当前是否在微信浏览器中运行
 */

/**
 * 检测是否在微信浏览器环境中
 * @returns {boolean} 是否在微信浏览器中
 */
export function isWeChatBrowser() {
  if (typeof window === 'undefined') {
    return false
  }

  const ua = window.navigator.userAgent.toLowerCase()
  
  // 检测微信浏览器 User-Agent
  // 微信浏览器的 User-Agent 包含 'micromessenger'
  return /micromessenger/i.test(ua)
}

/**
 * 检测是否需要在微信中访问（生产环境）
 * @returns {boolean} 是否需要检测微信环境
 */
export function shouldCheckWeChatEnv() {
  // 只在生产环境进行检测
  return process.env.NODE_ENV === 'production'
}

/**
 * 检查当前环境是否允许访问
 * @returns {boolean} 是否允许访问
 */
export function isAccessAllowed() {
  // 开发环境始终允许访问
  if (!shouldCheckWeChatEnv()) {
    return true
  }

  // 生产环境需要检查是否在微信中
  return isWeChatBrowser()
}

/**
 * 获取浏览器信息（用于调试）
 * @returns {Object} 浏览器信息
 */
export function getBrowserInfo() {
  if (typeof window === 'undefined') {
    return { userAgent: '', isWeChat: false }
  }

  return {
    userAgent: window.navigator.userAgent,
    isWeChat: isWeChatBrowser(),
    isProduction: process.env.NODE_ENV === 'production'
  }
}

export default {
  isWeChatBrowser,
  shouldCheckWeChatEnv,
  isAccessAllowed,
  getBrowserInfo
}
